import styled from "styled-components";
import { ReactComponent as ChevronIcon } from "../../assets/icons/chevronLeft.svg";

export const PaginationContainer = styled.ul`
  display: flex;
  gap: ${(p) => (p.$small ? "4px" : "8px")};
  @media (max-width: 500px) {
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 375px) {
    gap: ${(p) => (p.$small ? "3px" : "6px")};
  }
`;

export const ArrowContainer = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => (p.$small ? "30px" : "40px")};
  height: ${(p) => (p.$small ? "30px" : "40px")};
  border: 1px solid #333;
  background: transparent;
  border-radius: 100px;

  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ disabled }) => !disabled && "#333"};
    border-color: #2877d9;
  }

  opacity: ${({ disabled }) => disabled && 0.4};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ disabled }) => disabled && "none"};

  @media (max-width: 375px) {
    width: ${(p) => (p.$small ? "25px" : "35px")};
    height: ${(p) => (p.$small ? "25px" : "35px")};
  }
`;

export const ArrowIcon = styled(ChevronIcon)`
  color: ${(props) => (props.$disabled ? "#A9A9A970" : "#1672BA")};
  width: ${(p) => (p.$small ? "16px" : "24px")};
  height: ${(p) => (p.$small ? "16px" : "24px")};
  @media (max-width: 375px) {
    width: ${(p) => (p.$small ? "12px" : "20px")};
    height: ${(p) => (p.$small ? "12px" : "20px")};
  }
`;

export const RightArrowIcon = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

export const PaginationItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${(p) => (p.$small ? "30px" : "40px")};
  height: ${(p) => (p.$small ? "30px" : "40px")};
  padding: 0 8px;
  pointer-events: ${({ selected }) => selected && "none"};
  cursor: ${({ selected }) => (selected ? "not-allowed" : "pointer")};
  border: 1px solid ${({ selected }) => (selected ? "#2877D9" : "#333")};
  background: ${({ selected }) => (selected ? "#2877D9" : "transparent")};
  color: ${({ selected }) => (selected ? "#fff" : "#fff")};
  border-radius: 100px;

  transition: all 0.2s ease;
  font-family: Figtree;
  font-weight: 500;
  font-size: ${(p) => (p.$small ? "12px" : "14px")};

  &:hover {
    background: ${({ selected }) => (selected ? "#2877D9" : "#333")};
  }

  @media (max-width: 375px) {
    min-width: ${(p) => (p.$small ? "25px" : "35px")};
    height: ${(p) => (p.$small ? "25px" : "35px")};
    font-size: ${(p) => (p.$small ? "10px" : "12px")};
  }
`;
